import React from 'react';
import { AlertCircleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-[#FDF8F0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <div className="mb-16" data-id="element-157">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#3D2E1F] mb-6 text-center" data-id="element-158">
            El verdadero problema de la rigidez matutina
          </h2>
          <p className="text-[#3D2E1F]" data-id="element-159">
            A los 65 años, la rigidez no es solo una molestia; es un ladrón de
            independencia. Es el miedo a las escaleras, la frustración de no
            poder abrir un frasco de mermelada y el agotamiento de sentir que tu
            cuerpo tiene 20 años más de los que dice tu acta de nacimiento.
          </p>
          <p className="mt-4 text-[#3D2E1F]" data-id="element-160">
            Has probado cremas de olor fuerte, suplementos costosos y
            analgésicos que te irritan el estómago. El problema es que nada de
            eso llega a la raíz: la falta de flujo de líquido sinovial en el
            momento más crítico del día.
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-lg border border-[#F5EDE0]" data-id="element-161">
          <h3 className="font-playfair text-2xl md:text-3xl font-bold text-[#3D2E1F] mb-8 flex items-center gap-3" data-id="element-162">
            <AlertCircleIcon className="text-[#B8A068] w-8 h-8 flex-shrink-0" data-id="element-163" />
            Por qué lo que intentaste no funcionó:
          </h3>

          <ul className="space-y-6" role="list" data-id="element-164">
            <li className="flex items-start gap-4" data-id="element-165">
              <XCircleIcon className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-166" />
              <span className="text-[#3D2E1F]" data-id="element-167">
                <strong data-id="element-168">Las cremas tópicas</strong> solo "engañan" a los nervios
                de la piel, pero no lubrican la articulación profunda.
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-169">
              <XCircleIcon className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-170" />
              <span className="text-[#3D2E1F]" data-id="element-171">
                <strong data-id="element-172">Los ejercicios de impacto comunes</strong> dañan el
                cartílago desgastado en lugar de fortalecerlo.
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-173">
              <XCircleIcon className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-174" />
              <span className="text-[#3D2E1F]" data-id="element-175">
                <strong data-id="element-176">Los fármacos</strong> apagan la señal de dolor, pero
                dejan que la articulación siga "oxidándose" por falta de
                movimiento.
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-177">
              <XCircleIcon className="text-red-400 w-6 h-6 mt-1 flex-shrink-0" aria-hidden="true" data-id="element-178" />
              <span className="text-[#3D2E1F]" data-id="element-179">
                <strong data-id="element-180">Las rutinas largas de fisioterapia</strong> son
                imposibles de mantener cada mañana cuando apenas puedes moverte.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}